import { create } from "../../../common/utils/zustand_state_manager";
import { GestaoEpiRepository } from "../../../features/gestaoEpi/data/repositories/gestao_epi_repository";
import { IGestaoEpiRepository } from "../../../features/gestaoEpi/domain/repositories/gestao_epi_repository";
import { useGestaoEPIServices } from "./use_services";

/**
 * useGestaoEPIRepository
 */

type State = {
  gestaoEPIRepository: IGestaoEpiRepository,
};

export const useGestaoEPIRepository = create<State>((set, get) => {
  const { gestaoEPIService } = useGestaoEPIServices.getState();
  return ({
    gestaoEPIRepository: new GestaoEpiRepository(gestaoEPIService),
  });
});